import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage implements OnInit {
  userObj: any;
  access_token: string;
  constructor(
    private strg: StorageService,
    private router: Router,
    private authService: AuthenticationService
  ) { 
    this.strg.getStoreData("userObj").then(res=>{
      this.userObj = res;
    });

    this.strg.getStoreData("insAccessToken").then(res=>{
      this.access_token = res;
    });
  }

  ngOnInit() {
  }

  logoutClicked(){
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userObj.id).subscribe(ress => {
      console.log("token revoked!")
      this.strg.removeStoreData("userObj").then(res => {
        this.strg.removeStoreData("insAccessToken").then(res => {
          this.strg.removeStoreData("insRefreshToken").then(res => {
            this.authService.authState.next(false);
            // this.router.navigate(['/login']);
            // this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url }});
            window.open("https://www.mypolicyjunction.com/", "_self");
          });
        });
      });
    });
  }

}
